import React from "react";

const Playlist = (props) => {
  return <div>Playlist</div>;
};

export default Playlist;
